<div id="wrap">
  <div class="adesao">
    <h1>Solicitação de Adesão</h1>
    <div class="box adesao" #box>
      <div id="stepper1" class="bs-stepper">
        <div class="bs-stepper-header" #header>

          <div class="step" data-target="#test-l-7">
            <button class="step-trigger userlogin">
              <span class="bs-stepper-circle"><i class="fas fa-file-signature icone"></i>
              </span>
              <span class="bs-stepper-label">Termos e Aceites {{numTela}}</span>
            </button>
          </div>

          <div class="step" data-target="#test-l-5">
            <button class="step-trigger userlogin"
              [disabled]="!parentForm.get('tributacao')?.valid && !parentForm.get('concluido').value" style="pointer-events: none;">
              <span class="bs-stepper-circle">
                <i class="fas fa-dollar-sign icone"></i>
              </span>
              <span class="bs-stepper-label">Contribuição</span>
            </button>
          </div>


          <div class="step" data-target="#test-l-9">
            <button class="step-trigger" 
              [disabled]="!parentForm.get('assinaturaEletronica')?.valid && !parentForm.get('concluido').value" style="pointer-events: none;">
              <span class="bs-stepper-circle">
                <i class="fas fa-check-circle icone"></i>
              </span>
              <span class="bs-stepper-label"> Finalizar </span>
            </button>
          </div>

        </div>

        <div class="bs-stepper-content">
          <form (keydown.enter)="$event.preventDefault()">

            <div id="test-l-7" class="content">
              <div class="content-tab">
                <app-adesao-termos-aceites [parentForm]="parentForm"></app-adesao-termos-aceites>
              </div>
              <div class="footertabs">
                <button (click)="next('2')" class="btn btn_verde" [disabled]="!(parentForm.get('termos').valid) || this.parentForm.get('vinculo.idcTermoVinculo').value == 'N'">
                  AVANÇAR <i class="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>            

            <div id="test-l-5" class="content beneficiariostb">
              <div class="content-tab">
                <app-adesao-contribuicao [parentForm]="parentForm"></app-adesao-contribuicao>
              </div>
              <div class="footertabs">
                <a class="btn  btn_simulador" href="https://apps.vivamaisprev.com.br/simulador/escolha" target="blank">
                  Simulador</a>
                <!-- <button (click)="next('3')" class="btn wd51 btn_verde" [ngStyle]="{ 'opacity': parentForm.get('contribuicao')?.valid ? '1' : '0.5' }"> -->
                <button (click)="next('3')" class="btn wd51 btn_verde" >
                
                  AVANÇAR <i class="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>           

            <div id="test-l-9" class="content beneficiariostb">
              <div class="content-tab">
                <app-fim-adesao [parentForm]="parentForm" ></app-fim-adesao>
              </div>
              <div class="footertabs">
                <button class="btn btn_verde" [disabled]="!botaoAtivo" (click)="finalizarAdesao()">
                  FINALIZAR <i class="fas fa-check"></i>
                </button>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Termos Instituidores-->

<div class="modal fade" id="modalTermoAbrapp" data-backdrop="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-body">
        <form (submit)="ngOnInit()">
          <p>
            A ABRAPP – Associação Brasileira das Entidades Fechadas de Previdência
            Complementar é a Instituidora do plano de benefícios setorial Viva Mais
            Previdência sendo o vínculo associativo com a mesma necessário para o
            acesso ao plano de benefícios, o que ocorrerá na forma de filiação como
            Associado Especial Previdenciário da ABRAPP, sem qualquer custo ou
            obrigação. Acesso ao Estatuto da ABRAPP:
            <a href="https://www.abrapp.org.br/wp-content/uploads/2022/12/Estatuto-Social-Abrapp-2022-AGE-09.11.pdf"
              target="blank">
              https://www.abrapp.org.br/wp-content/uploads/2022/12/Estatuto-Social-Abrapp-2022-AGE-09.11.pdf</a>
          </p>

          <strong class="title">PEDIDO DE FILIAÇÃO</strong>
          <h3 class="titlediretoria">
            À <br />Diretoria Integrada do Sistema ABRAPP
          </h3>

          <p>
            Eu <strong> {{ participante.nome }} </strong>, inscrito(a) no CPF/MF sob o nº <strong>{{ participante.cpf }}</strong>, por meio do presente venho requerer minha
            filiação ao quadro associativo da ABRAPP na qualidade de Associado
            Especial Previdenciário da ABRAPP, exclusivamente para fins de inscrição
            ao Plano de Benefícios Setorial Viva Mais Previdência oferecido por
            Fundação Sanepar de Previdência e Assistência Social – Fusan.
          </p>
          <p>
            Ao assinar o presente, declaro estar ciente do inteiro teor do Estatuto
            Social da ABRAPP, bem como dos direitos e deveres impostos aos seus
            membros.
          </p>
          <p>
            Autorizo que os dados pessoais aqui informados sejam utilizados para
            fins de filiação à ABRAPP e que os mesmos serão protegidos atendendo ao
            disposto na Lei nº 13.709/2018. Curitiba, {{participante.dataAtual}}.
          </p>
        </form>
      </div>

      <div class="termos">
        <div class="form-check">
          <input id="decInstituidorAbrapp" [checked]="this.parentForm.get('termos.decInstituidor').value == 'S'"
            class="form-check-input" type="checkbox" (input)="onChangePermission($event.target.checked)" />
          <label class="form-check-label" for="decInstituidorAbrapp">
            Li e aceito os termos do pedido de filiação a ABRAPP
          </label>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn_verde" data-dismiss="modal"
          [disabled]="!(this.parentForm.get('termos.decInstituidor').value == 'S')">
          OK
        </button>
      </div>

    </div>
  </div>
</div>

<div class="modal fade" id="modalTermoASPP" data-backdrop="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-body">
        <form (submit)="ngOnInit()">
          <p>
            <strong>A ASPP - ASSOCIAÇÃO DOS SERVIDORES PÚBLICOS DO PARANÁ</strong> é a instituidora do plano de benefícios setorial <strong>Viva Mais Previdência</strong>, oferecendo vantagens exclusivas aos seus associados para acesso ao referido plano, sem qualquer custo ou obrigação adicional.
            Acesso ao Estatuto da ASPP:
            <a href="http://www.aspp.org.br/estatuto" target="blank">www.aspp.org.br/estatuto</a>
          </p>

          <strong class="title">DECLARAÇÃO DE ASSOCIADO ASPP</strong>
        
          <p>
            Eu, <strong> {{ participante.nome }} </strong>, inscrito(a) no CPF/MF sob o nº <strong>{{ participante.cpf}}</strong>, declaro, para os devidos fins, minha adesão ao Plano de Benefícios Setorial <strong>Viva Mais Previdência</strong>, 
            oferecido pela <strong>Fundação Sanepar de Previdência e Assistência Social – FUSAN</strong>, na condição de associado da <strong>ASPP - Associação dos Servidores Públicos do Paraná</strong>.
          </p>

          <p>
            Ao assinar este termo, declaro estar ciente do inteiro teor do Estatuto Social da ASPP, bem como dos direitos e deveres decorrentes da minha adesão ao plano.
          </p>

          <p>
            <strong>Estou ciente de que, em caso de desligamento da ASPP, as vantagens oferecidas aos associados não serão mantidas, mas poderei dar continuidade em minha previdência complementar junto à FUSAN.</strong>
          </p>

          <p>
            Autorizo que os dados pessoais aqui informados sejam utilizados exclusivamente para a administração do Plano de Benefícios Setorial Viva Mais Previdência, em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018).
          </p>
        </form>
      </div>

      <div class="termos">
        <div class="form-check">
          <input id="decInstituidorAbrapp" [checked]="this.parentForm.get('termos.decInstituidor').value == 'S'"
            class="form-check-input" type="checkbox" (input)="onChangePermission($event.target.checked)" />
          <label class="form-check-label" for="decInstituidorAbrapp">
            Li e aceito os termos do presente termo de adesão.
          </label>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn_verde" data-dismiss="modal"
          [disabled]="!(this.parentForm.get('termos.decInstituidor').value == 'S')">
          OK
        </button>
      </div>

    </div>
  </div>
</div>

<div class="modal fade" id="modalTermoAfa" data-backdrop="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-body">
        <form (submit)="ngOnInit()">
          <p>
            A AFA-PR - Associação dos Funcionários da Emater é a Instituidora do plano de
            benefícios setorial Viva Mais Previdência, aqui denominado plano GERA, sendo o
            vínculo associativo com a mesma necessário para o acesso ao plano de benefícios,
            o que ocorrerá na forma de filiação como Associado Especial Previdenciário da AFA-
            PR, sem qualquer custo ou obrigação. Acesso ao Estatuto da AFA-PR:
            <a href="https://afapr.org.br/downloads_down/estatuto-social" target="blank">
              https://afapr.org.br/downloads_down/estatuto-social
            </a>
          </p>

          <strong class="title">PEDIDO DE FILIAÇÃO</strong>
          <h3 class="titlediretoria">
            À <br />Diretoria Integrada do Sistema AFA-PR
          </h3>

          <p>
            Eu <strong> {{ participante.nome }} </strong>, inscrito(a) no CPF/MF sob o nº <strong>{{ participante.cpf }}</strong>, 
            por meio do presente venho requerer minha filiação ao quadro associativo da AFA-PR na qualidade de Associado Especial
            Previdenciário da AFA-PR, exclusivamente para fins de inscrição ao Plano de
            Benefícios Setorial Viva Mais Previdência, , aqui denominado plano GERA, oferecido
            por Fundação Sanepar de Previdência e Assistência Social - Fusan.
          </p>
          <p>
            Ao assinar o presente, declaro estar ciente do inteiro teor do Estatuto Social da AFA-
            PR, bem como dos direitos e deveres impostos aos seus membros.
          </p>
          <p>
            Autorizo que os dados pessoais aqui informados sejam utilizados para fins de
            filiação à AFA-PR e que os mesmos serão protegidos atendendo ao disposto na Lei
            nº 13.709/2018. Curitiba, {{participante.dataAtual}}.
          </p>
        </form>
      </div>

      <div class="termos">
        <div class="form-check">
          <input id="decInstituidorAfa" [checked]="this.parentForm.get('termos.decInstituidor').value == 'S'"
            class="form-check-input" type="checkbox" (input)="onChangePermission($event.target.checked)" />
          <label class="form-check-label" for="decInstituidorAfa">
            Li e aceito os termos do pedido de filiação a AFA-PR
          </label>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn_verde" data-dismiss="modal"
          [disabled]="!(this.parentForm.get('termos.decInstituidor').value == 'S')">
          OK
        </button>
      </div>

    </div>
  </div>
</div>